import Base from 'netxcore@netx/core-cms/models/CMSPage';

import CMSBlockModel from './CMSBlock';
import CMSBlocksCollection from '@netx/core-cms/collections/CMSBlocks';

/**
 * @override
 */
export default class CMSPage extends Base {
	/** @override */
	constructor(attrs, opts = {}) {
		super(attrs, opts);

		// have we parsed our blocks yet
		this.parsed = opts.parsed === true;
	}

	/** @method */
	parseBlocks() {
		if (this.parsed) return;
		const blocksCollection = this.get('blocks');
		blocksCollection.each((block, idx, all) => {
			block._parse(block.attributes, {parse: true});
		});
		this.parsed = true;
	}

	/**
	 * Set our blocks property, converting non-models into models & fetching them as needed.
	 */
	setBlocks(blocks, opts) {
		if (!blocks || blocks.length == 0) {
			blocks = [new CMSBlockModel({type: 'html'})];
		}
		const blockCollection = _.toCollection(blocks, CMSBlocksCollection, {
			parse: false,
		});

		if (
			this.get('blocks') &&
			this.get('blocks').constructor.__name__ === 'CMSBlocks'
		) {
			// Update existing blocks collection
			this.get('blocks').reset(blockCollection.models, {parse: false});
		} else {
			// Attach new blocks collection
			this.set({blocks: blockCollection}, {parse: false});
		}
	}
}
